/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { createSlice } from "@reduxjs/toolkit";

import { RequestStatus } from "~/constants";
import { setPasswordAsync } from "~/features/setPassword/thunks";
import { SetPasswordState } from "~/features/setPassword/types";

const initialState: SetPasswordState = {
  setPasswordStatus: RequestStatus.IDLE,
  setPasswordMessage: null,
};

const slice = createSlice({
  name: "setPassword",
  initialState,
  reducers: {
    resetSetPassword: (state) => {
      state.setPasswordStatus = RequestStatus.IDLE;
      state.setPasswordMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setPasswordAsync.pending, (state) => {
        state.setPasswordStatus = RequestStatus.PENDING;
      })

      .addCase(setPasswordAsync.fulfilled, (state) => {
        state.setPasswordStatus = RequestStatus.SUCCESS;
        state.setPasswordMessage = "set_password.success.message";
      })

      .addCase(setPasswordAsync.rejected, (state) => {
        state.setPasswordStatus = RequestStatus.ERROR;
      });
  },
});

export const SetPasswordActions = slice.actions;

export const setPasswordReducer = slice.reducer;
